/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CreateSupportRequest400Response,
    CreateSupportRequest400ResponseFromJSON,
    CreateSupportRequest400ResponseToJSON,
} from '../models/CreateSupportRequest400Response';
import {
    type DisableClientNotificationRequest,
    DisableClientNotificationRequestFromJSON,
    DisableClientNotificationRequestToJSON,
} from '../models/DisableClientNotificationRequest';
import {
    type GetDisabledClientNotifications200Response,
    GetDisabledClientNotifications200ResponseFromJSON,
    GetDisabledClientNotifications200ResponseToJSON,
} from '../models/GetDisabledClientNotifications200Response';
import {
    type GetMfaCredentials200Response,
    GetMfaCredentials200ResponseFromJSON,
    GetMfaCredentials200ResponseToJSON,
} from '../models/GetMfaCredentials200Response';
import {
    type GetPasswordChangeLink200Response,
    GetPasswordChangeLink200ResponseFromJSON,
    GetPasswordChangeLink200ResponseToJSON,
} from '../models/GetPasswordChangeLink200Response';
import {
    type GetUser200Response,
    GetUser200ResponseFromJSON,
    GetUser200ResponseToJSON,
} from '../models/GetUser200Response';
import {
    type GetWellKnownEmailServices401Response,
    GetWellKnownEmailServices401ResponseFromJSON,
    GetWellKnownEmailServices401ResponseToJSON,
} from '../models/GetWellKnownEmailServices401Response';
import {
    type GetWellKnownEmailServices500Response,
    GetWellKnownEmailServices500ResponseFromJSON,
    GetWellKnownEmailServices500ResponseToJSON,
} from '../models/GetWellKnownEmailServices500Response';
import {
    type SetChangelogSubscriptionRequest,
    SetChangelogSubscriptionRequestFromJSON,
    SetChangelogSubscriptionRequestToJSON,
} from '../models/SetChangelogSubscriptionRequest';
import {
    type UpdateOnboardingRequest,
    UpdateOnboardingRequestFromJSON,
    UpdateOnboardingRequestToJSON,
} from '../models/UpdateOnboardingRequest';
import {
    type ValidateSession200Response,
    ValidateSession200ResponseFromJSON,
    ValidateSession200ResponseToJSON,
} from '../models/ValidateSession200Response';

export interface DeleteMfaCredentialRequest {
    /**
     * 
     */
    credentialId: string;
}

export interface DisableClientNotificationOperationRequest {
    /**
     * 
     */
    disableClientNotificationRequest: DisableClientNotificationRequest;
}

export interface EnableClientNotificationRequest {
    /**
     * 
     */
    clientUUID: string;
}

export interface GetMfaRegisterLinkRequest {
    /**
     * 
     */
    method: GetMfaRegisterLinkMethodEnum;
}

export interface SetChangelogSubscriptionOperationRequest {
    /**
     * 
     */
    setChangelogSubscriptionRequest: SetChangelogSubscriptionRequest;
}

export interface UpdateOnboardingOperationRequest {
    /**
     * 
     */
    updateOnboardingRequest: UpdateOnboardingRequest;
}

export interface UpdateUserRequest {
    /**
     * Keycloak user object
     */
    getUser200Response: GetUser200Response;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * Creates request options for deleteMfaCredential without sending the request
     */
    async deleteMfaCredentialRequestOpts(requestParameters: DeleteMfaCredentialRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['credentialId'] == null) {
            throw new runtime.RequiredError(
                'credentialId',
                'Required parameter "credentialId" was null or undefined when calling deleteMfaCredential().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/mfa/credentials/{credentialId}`;
        urlPath = urlPath.replace('{credentialId}', encodeURIComponent(String(requestParameters['credentialId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Remove one registered MFA method. Fails if it would leave the user without any MFA method.  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async deleteMfaCredentialRaw(requestParameters: DeleteMfaCredentialRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteMfaCredentialRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove one registered MFA method. Fails if it would leave the user without any MFA method.  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async deleteMfaCredential(credentialId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMfaCredentialRaw({ credentialId: credentialId }, initOverrides);
    }

    /**
     * Creates request options for disableClientNotification without sending the request
     */
    async disableClientNotificationRequestOpts(requestParameters: DisableClientNotificationOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['disableClientNotificationRequest'] == null) {
            throw new runtime.RequiredError(
                'disableClientNotificationRequest',
                'Required parameter "disableClientNotificationRequest" was null or undefined when calling disableClientNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/notification/client-disabled`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DisableClientNotificationRequestToJSON(requestParameters['disableClientNotificationRequest']),
        };
    }

    /**
     * Disable all notifications for a specific client  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async disableClientNotificationRaw(requestParameters: DisableClientNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.disableClientNotificationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Disable all notifications for a specific client  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async disableClientNotification(disableClientNotificationRequest: DisableClientNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.disableClientNotificationRaw({ disableClientNotificationRequest: disableClientNotificationRequest }, initOverrides);
    }

    /**
     * Creates request options for enableClientNotification without sending the request
     */
    async enableClientNotificationRequestOpts(requestParameters: EnableClientNotificationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling enableClientNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/notification/client-disabled/{clientUUID}`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Re-enable notifications for a specific client  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async enableClientNotificationRaw(requestParameters: EnableClientNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.enableClientNotificationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Re-enable notifications for a specific client  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async enableClientNotification(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.enableClientNotificationRaw({ clientUUID: clientUUID }, initOverrides);
    }

    /**
     * Creates request options for endKeycloakSession without sending the request
     */
    async endKeycloakSessionRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/keycloak/end-session`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * End user Keycloak user session  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async endKeycloakSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const requestOptions = await this.endKeycloakSessionRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * End user Keycloak user session  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async endKeycloakSession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.endKeycloakSessionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDisabledClientNotifications without sending the request
     */
    async getDisabledClientNotificationsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/notification/client-disabled`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get list of client UUIDs for which notifications are disabled  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getDisabledClientNotificationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDisabledClientNotifications200Response>> {
        const requestOptions = await this.getDisabledClientNotificationsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDisabledClientNotifications200ResponseFromJSON(jsonValue));
    }

    /**
     * Get list of client UUIDs for which notifications are disabled  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getDisabledClientNotifications(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDisabledClientNotifications200Response> {
        const response = await this.getDisabledClientNotificationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMfaCredentials without sending the request
     */
    async getMfaCredentialsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/mfa/credentials`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List the current user\'s registered login methods (password, TOTP, passkey, security key)  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getMfaCredentialsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMfaCredentials200Response>> {
        const requestOptions = await this.getMfaCredentialsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMfaCredentials200ResponseFromJSON(jsonValue));
    }

    /**
     * List the current user\'s registered login methods (password, TOTP, passkey, security key)  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getMfaCredentials(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMfaCredentials200Response> {
        const response = await this.getMfaCredentialsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMfaManagementLink without sending the request
     */
    async getMfaManagementLinkRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/mfa/manage`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Keycloak Account Console link where the user can add, update and remove login methods (TOTP, passkey, security key)  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getMfaManagementLinkRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPasswordChangeLink200Response>> {
        const requestOptions = await this.getMfaManagementLinkRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPasswordChangeLink200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Keycloak Account Console link where the user can add, update and remove login methods (TOTP, passkey, security key)  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getMfaManagementLink(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPasswordChangeLink200Response> {
        const response = await this.getMfaManagementLinkRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMfaRegisterLink without sending the request
     */
    async getMfaRegisterLinkRequestOpts(requestParameters: GetMfaRegisterLinkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['method'] == null) {
            throw new runtime.RequiredError(
                'method',
                'Required parameter "method" was null or undefined when calling getMfaRegisterLink().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['method'] != null) {
            queryParameters['method'] = requestParameters['method'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/mfa/register-link`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a Keycloak link that starts registration of a new MFA method (authenticator app or passkey) and redirects back to the app  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getMfaRegisterLinkRaw(requestParameters: GetMfaRegisterLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPasswordChangeLink200Response>> {
        const requestOptions = await this.getMfaRegisterLinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPasswordChangeLink200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a Keycloak link that starts registration of a new MFA method (authenticator app or passkey) and redirects back to the app  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getMfaRegisterLink(method: GetMfaRegisterLinkMethodEnum, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPasswordChangeLink200Response> {
        const response = await this.getMfaRegisterLinkRaw({ method: method }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPasswordChangeLink without sending the request
     */
    async getPasswordChangeLinkRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/password/change`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Keycloak password change link  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getPasswordChangeLinkRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPasswordChangeLink200Response>> {
        const requestOptions = await this.getPasswordChangeLinkRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPasswordChangeLink200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Keycloak password change link  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getPasswordChangeLink(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPasswordChangeLink200Response> {
        const response = await this.getPasswordChangeLinkRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSubscriptionUpdateEmail without sending the request
     */
    async getSubscriptionUpdateEmailRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/email-subscription/update`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Update email subscription user  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getSubscriptionUpdateEmailRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.getSubscriptionUpdateEmailRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update email subscription user  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getSubscriptionUpdateEmail(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getSubscriptionUpdateEmailRaw(initOverrides);
    }

    /**
     * Creates request options for getUser without sending the request
     */
    async getUserRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Keycloak user  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUser200Response>> {
        const requestOptions = await this.getUserRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUser200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Keycloak user  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async getUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUser200Response> {
        const response = await this.getUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for handleUserWebhooks without sending the request
     */
    async handleUserWebhooksRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/webhook`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Keycloak webhooks
     */
    async handleUserWebhooksRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const requestOptions = await this.handleUserWebhooksRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get Keycloak webhooks
     */
    async handleUserWebhooks(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.handleUserWebhooksRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setChangelogSubscription without sending the request
     */
    async setChangelogSubscriptionRequestOpts(requestParameters: SetChangelogSubscriptionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['setChangelogSubscriptionRequest'] == null) {
            throw new runtime.RequiredError(
                'setChangelogSubscriptionRequest',
                'Required parameter "setChangelogSubscriptionRequest" was null or undefined when calling setChangelogSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/changelog-subscription`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetChangelogSubscriptionRequestToJSON(requestParameters['setChangelogSubscriptionRequest']),
        };
    }

    /**
     * Subscribe (opt-in, logged as consent) or unsubscribe the current user to/from the changelog e-mails  **Authorized Roles:** `serviceprovider`
     */
    async setChangelogSubscriptionRaw(requestParameters: SetChangelogSubscriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.setChangelogSubscriptionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Subscribe (opt-in, logged as consent) or unsubscribe the current user to/from the changelog e-mails  **Authorized Roles:** `serviceprovider`
     */
    async setChangelogSubscription(setChangelogSubscriptionRequest: SetChangelogSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setChangelogSubscriptionRaw({ setChangelogSubscriptionRequest: setChangelogSubscriptionRequest }, initOverrides);
    }

    /**
     * Creates request options for updateOnboarding without sending the request
     */
    async updateOnboardingRequestOpts(requestParameters: UpdateOnboardingOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['updateOnboardingRequest'] == null) {
            throw new runtime.RequiredError(
                'updateOnboardingRequest',
                'Required parameter "updateOnboardingRequest" was null or undefined when calling updateOnboarding().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/onboarding`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOnboardingRequestToJSON(requestParameters['updateOnboardingRequest']),
        };
    }

    /**
     * Update the onboarding state of the current user. `completed: false` restarts the onboarding.  **Authorized Roles:** `serviceprovider`
     */
    async updateOnboardingRaw(requestParameters: UpdateOnboardingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateOnboardingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the onboarding state of the current user. `completed: false` restarts the onboarding.  **Authorized Roles:** `serviceprovider`
     */
    async updateOnboarding(updateOnboardingRequest: UpdateOnboardingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOnboardingRaw({ updateOnboardingRequest: updateOnboardingRequest }, initOverrides);
    }

    /**
     * Creates request options for updateUser without sending the request
     */
    async updateUserRequestOpts(requestParameters: UpdateUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['getUser200Response'] == null) {
            throw new runtime.RequiredError(
                'getUser200Response',
                'Required parameter "getUser200Response" was null or undefined when calling updateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetUser200ResponseToJSON(requestParameters['getUser200Response']),
        };
    }

    /**
     * Update user  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async updateUserRaw(requestParameters: UpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update user  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async updateUser(getUser200Response: GetUser200Response, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserRaw({ getUser200Response: getUser200Response }, initOverrides);
    }

    /**
     * Creates request options for validateSession without sending the request
     */
    async validateSessionRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/session/validate`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Validate user session  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async validateSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateSession200Response>> {
        const requestOptions = await this.validateSessionRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateSession200ResponseFromJSON(jsonValue));
    }

    /**
     * Validate user session  **Authorized Roles:** `serviceprovider`, `client`, `admin`, `collector`, `reseller`, `api_user`
     */
    async validateSession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateSession200Response> {
        const response = await this.validateSessionRaw(initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetMfaRegisterLinkMethodEnum = {
    Totp: 'totp',
    Passkey: 'passkey',
} as const;
export type GetMfaRegisterLinkMethodEnum = typeof GetMfaRegisterLinkMethodEnum[keyof typeof GetMfaRegisterLinkMethodEnum];
